import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { ReloadOutlined } from '@ant-design/icons'

import SButton from '../common/SButton'
import { isChunkLoadError, reloadApp } from './version.utils'

import './index.css'

function StaleVersionScreen() {
    const { t } = useTranslation()

    return (
        <div className="stale-version-screen">
            <h1>{t('A new version of Scoring.fit is available.')}</h1>
            <p>{t('This page could not be loaded because Scoring.fit was updated while you were browsing.')}</p>
            <p>{t('Reload the page to continue.')}</p>
            <SButton value={t('Reload')} Icon={ReloadOutlined} iconLocation="left" onClick={reloadApp} />
        </div>
    )
}

/**
 * Catches a lazy route whose chunk vanished from the server after a deploy and shows a
 * "reload" screen instead of a blank page. Resets whenever the route changes so the user can
 * keep navigating to pages already loaded in this tab. Any other error is re-thrown untouched.
 */
class ChunkErrorBoundaryInner extends React.Component {
    constructor(props) {
        super(props)
        this.state = { error: null }
    }

    static getDerivedStateFromError(error) {
        return { error }
    }

    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ error: null })
        }
    }

    render() {
        const { error } = this.state
        if (!error) return this.props.children
        if (!isChunkLoadError(error)) throw error
        return <StaleVersionScreen />
    }
}

export default function ChunkErrorBoundary({ children }) {
    const location = useLocation()
    return <ChunkErrorBoundaryInner resetKey={location.pathname}>{children}</ChunkErrorBoundaryInner>
}
